export default "__VITE_ASSET__CuH$3Inc__"